import React from 'react';
import { formatDate, formatRelativeTime } from '../../utils/dateFormatter';
import { getPlatformDisplayName } from '../../utils/platformUtils';
import { TEXT, lateReasonText } from '../../config/guestReviewLabels';
import TaskLinkButton from './TaskLinkButton';

/**
 * A departed stay whose turnover clean is still open (tasks/post-checkout-review-and-replies.md L10,
 * L51). Nothing can be prepared until the clean closes. The verdict — late or "could not determine" —
 * and who it waits on come from the server; this row only shows them. A future AI follow-up agent reads
 * the same verdict and does the chasing.
 */
const LateCleanRow = ({ row, onOpenTask, loadingTaskId }) => {
  const { verdict } = row;
  const late = verdict.status === 'LATE';
  return (
    <div className={`gr-late-row ${late ? 'gr-late-row--late' : 'gr-late-row--unverified'}`}>
      <div className="gr-late-main">
        <span className="gr-unit">{row.unit?.name}</span>
        {row.unit?.code && <span className="gr-code" dir="ltr">{row.unit.code}</span>}
        <span className="gr-muted">· {row.guestName}</span>
        <span className="gr-muted">· {getPlatformDisplayName(row.platform)}</span>
      </div>
      <div className="gr-details">
        <span>{lateReasonText(verdict)}</span>
        {row.checkoutAt && <span>{TEXT.departed} {formatDate(row.checkoutAt)}</span>}
        {late && verdict.since && <span>{TEXT.since} {formatRelativeTime(verdict.since)}</span>}
        <span>
          {TEXT.waitingOn}: {verdict.waitingOn ? (verdict.waitingOn.name || '—') : TEXT.unassigned}
        </span>
      </div>
      <TaskLinkButton
        taskId={row.taskId}
        ticketId={row.ticketId}
        onOpen={onOpenTask}
        loading={loadingTaskId === row.taskId}
      />
    </div>
  );
};

export default LateCleanRow;
